// Service pour gérer les limites de requêtes pour les utilisateurs non connectés
const STORAGE_KEY = 'chat_requests_count';
const STORAGE_DATE_KEY = 'chat_requests_date';
const MAX_REQUESTS = 5;

class ChatLimitService {
  // Vérifier si l'utilisateur peut faire une requête
  canMakeRequest(isAuthenticated: boolean): { allowed: boolean; remaining: number; message?: string } {
    // Si l'utilisateur est connecté, pas de limite
    if (isAuthenticated) {
      return { allowed: true, remaining: Infinity };
    }

    // Vérifier la date du jour
    const today = new Date().toDateString();
    const storedDate = localStorage.getItem(STORAGE_DATE_KEY);

    // Si c'est un nouveau jour, réinitialiser le compteur
    if (storedDate !== today) {
      localStorage.setItem(STORAGE_KEY, '0');
      localStorage.setItem(STORAGE_DATE_KEY, today);
      return { allowed: true, remaining: MAX_REQUESTS };
    }

    // Lire le nombre de requêtes
    const count = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);

    if (count >= MAX_REQUESTS) {
      return {
        allowed: false,
        remaining: 0,
        message: `Vous avez atteint la limite de ${MAX_REQUESTS} requêtes gratuites aujourd'hui. Connectez-vous pour continuer à utiliser le chat sans limite !`,
      };
    }

    return {
      allowed: true,
      remaining: MAX_REQUESTS - count,
    };
  }

  // Enregistrer une requête
  recordRequest(isAuthenticated: boolean): void {
    // Si l'utilisateur est connecté, ne pas enregistrer
    if (isAuthenticated) {
      return;
    }

    const today = new Date().toDateString();
    const storedDate = localStorage.getItem(STORAGE_DATE_KEY);

    // Si c'est un nouveau jour, réinitialiser
    if (storedDate !== today) {
      localStorage.setItem(STORAGE_KEY, '1');
      localStorage.setItem(STORAGE_DATE_KEY, today);
      return;
    }

    // Incrémenter le compteur
    const count = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    localStorage.setItem(STORAGE_KEY, (count + 1).toString());
  }

  // Obtenir le nombre de requêtes restantes
  getRemainingRequests(isAuthenticated: boolean): number {
    if (isAuthenticated) {
      return Infinity;
    }

    const today = new Date().toDateString();
    const storedDate = localStorage.getItem(STORAGE_DATE_KEY);

    if (storedDate !== today) {
      return MAX_REQUESTS;
    }

    const count = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    return Math.max(0, MAX_REQUESTS - count);
  }

  // Réinitialiser le compteur (pour les tests)
  reset(): void {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_DATE_KEY);
  }
}

export const chatLimitService = new ChatLimitService();

